import { createSlice } from '@reduxjs/toolkit';

import type { AsyncStatus } from '@/shared/types/asyncState';

import type { AvaliacaoGlobal } from '../../types/operacoes';
import { fetchAvaliacoesGlobais } from './actions';

interface AvaliacoesGlobaisState {
  items: AvaliacaoGlobal[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: AvaliacoesGlobaisState = {
  items: [],
  pagination: { page: 1, limit: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
  status: 'idle',
};

const avaliacoesGlobaisSlice = createSlice({
  name: 'avaliacoesGlobais',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.status = 'idle';
    },
    resetAvaliacoesGlobais: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvaliacoesGlobais.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchAvaliacoesGlobais.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
        state.pagination = action.payload.pagination;
        state.status = 'success';
      })
      .addCase(fetchAvaliacoesGlobais.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { clearError, resetAvaliacoesGlobais } = avaliacoesGlobaisSlice.actions;
export const avaliacoesGlobaisReducer = avaliacoesGlobaisSlice.reducer;
